import type { PublicParishLandingPayload } from '../services/parishLandingService';

/** Fallback se a API da home da marca falhar — nunca voltar ao mosaico católico. */
export const ZUADARIA_FALLBACK_LANDING: PublicParishLandingPayload = {
  targetType: 'landing',
  parishId: 'zuadaria',
  parishSlug: 'zuadaria',
  parishName: 'Zuadaria',
  brandKey: 'zuadaria',
  landing: {
    id: 'zuadaria',
    parishId: 'zuadaria',
    template: 'comedy_club',
    published: true,
    profile: {
      title: 'Zuadaria',
      bio: '',
      avatarUrl: '',
      coverUrl: '',
    },
    theme: {
      primaryColor: '#B84D4D',
      secondaryColor: '#E6A532',
      background: '',
    },
    eventIds: [],
    links: [],
    events: [],
  },
  paths: {
    home: '/',
    preview: '/',
  },
};
